// Sidebar Mega Menu Navigation
document.addEventListener('DOMContentLoaded', function() {
  // Handle both click and hover for sidebar navigation
  const navItems = document.querySelectorAll('.sidebar-mega-menu__nav-item[data-target]');
  
  navItems.forEach(item => {
    // Click handler
    item.addEventListener('click', function(e) {
      e.preventDefault();
      switchContent(this);
    });
    
    // Hover handler  
    item.addEventListener('mouseenter', function() {
      switchContent(this);
    });
  });
  
  function switchContent(activeItem) {
    const target = activeItem.getAttribute('data-target');
    const parentMenu = activeItem.closest('.sidebar-mega-menu');
    
    if (!parentMenu) return;
    
    // Remove active class from all nav items and content sections in this menu
    const siblingNavItems = parentMenu.querySelectorAll('.sidebar-mega-menu__nav-item[data-target]');
    const siblingContentSections = parentMenu.querySelectorAll('.sidebar-mega-menu__content-section');
    
    siblingNavItems.forEach(nav => nav.classList.remove('active'));
    siblingContentSections.forEach(section => section.classList.remove('active'));
    
    // Add active class to hovered/clicked nav item and corresponding content
    activeItem.classList.add('active');
    const targetSection = parentMenu.querySelector('#' + target);
    if (targetSection) {
      targetSection.classList.add('active');
    }
  }
});